<template>
  <ProductionInventoryStock kind="raw" />
</template>
<script setup>
import ProductionInventoryStock from '@/components/module/production/ProductionInventoryStock.vue';
</script>
